import React from 'react';

import { Flex } from '@skippay/core/components/Flex';
import Text from '@skippay/core/components/Text';
import { FormattedMessage } from '@skippay/core/i18n/intl';

import { SBadge, SBox, SLine, SLineText } from './index.styled';

interface Props {
	box: {
		button?: JSX.Element;
		badge?: JSX.Element;
		footer?: JSX.Element;
		icon?: JSX.Element;
		size?: 'sm' | 'lg';
		text: JSX.Element;
		title: JSX.Element;
	};
	disabled?: boolean;
	link?: JSX.Element;
}

interface CompactProps {
	button: JSX.Element;
	link: JSX.Element;
}

const Link = ({
	isCompactView,
	link,
}: {
	isCompactView?: boolean;
	link: JSX.Element;
}): JSX.Element => (
	<div className="textCenter">
		<SLine className="mt-10!">
			<SLineText>
				<Text size="paragraphSmall">
					<FormattedMessage defaultMessage="nebo" id="SelectItemBoxAndLink.or" />
				</Text>
			</SLineText>
		</SLine>
		<Text size="paragraphSmall" className={isCompactView ? 'mt-10!' : 'mt-8!'}>
			{link}
		</Text>
	</div>
);

export const CompactSelectItemBoxAndLink = ({ button, link }: CompactProps): JSX.Element => (
	<>
		{button}
		<Link isCompactView link={link} />
	</>
);

function SelectItemBoxAndLink({
	box: { badge, button, footer, icon, size, text, title },
	disabled,
	link,
}: Props): JSX.Element {
	return (
		<>
			<SBox
				noShadow
				borderRadius="lg"
				overflowVisible
				fullHeight
				bgColor="blue-100"
				boxSize={size || 'sm'}
				disabled={disabled}
			>
				{badge && <SBadge spacing={size || 'sm'}>{badge}</SBadge>}
				<Flex variant="column" justify="between">
					{icon && <div className="u-m-auto mb-8!">{icon}</div>}
					<Text as="h3" size="h3" align="center">
						{title}
					</Text>
					<div className="textCenter mt-2!">{text}</div>
					{footer && <div className="mt-4!">{footer}</div>}
					{button && <div className="mt-5!">{button}</div>}
				</Flex>
			</SBox>
			{link && <Link link={link} />}
		</>
	);
}

export default SelectItemBoxAndLink;
